var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSave(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M37.5 43.75H12.5C9.04792 43.75 6.25 40.9521 6.25 37.5V12.5C6.25 9.04792 9.04792 6.25 12.5 6.25H34.9104C36.5687 6.25 38.1583 6.90833 39.3292 8.08125L41.9188 10.6708C43.0917 11.8417 43.75 13.4312 43.75 15.0896V37.5C43.75 40.9521 40.9521 43.75 37.5 43.75Z",
    fill: "#3069E1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.25 6.25C30.1 6.25 29.1666 7.18333 29.1666 8.33333V12.5C29.1666 13.65 28.2333 14.5833 27.0833 14.5833C25.9333 14.5833 25 13.65 25 12.5V8.33333C25 7.18333 24.0666 6.25 22.9166 6.25H18.75C17.6 6.25 16.6666 7.18333 16.6666 8.33333V16.6667C16.6666 17.8167 17.6 18.75 18.75 18.75H31.25C32.4 18.75 33.3333 17.8167 33.3333 16.6667V8.33333C33.3333 7.18333 32.4 6.25 31.25 6.25Z",
    fill: "#4671F6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 29.1667C37.5 26.8646 35.6354 25 33.3333 25H16.6667C14.3646 25 12.5 26.8646 12.5 29.1667V43.75H37.5V29.1667Z",
    fill: "#4671F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSave);
export default __webpack_public_path__ + "static/media/save.1408e766db04c3669154c42cdd12d059.svg";
export { ForwardRef as ReactComponent };